export default __webpack_public_path__ + "static/media/practice_img.bb2f2726.jpg";